<template>
    <v-container fluid>
        <v-row align="center" justify="center" class="Report">
            <v-col cols="11">

                <div class="Report__heading">
                    <h2 v-if="user.role === 'admin'">Site: {{ userData.name }}</h2>
                    <v-spacer></v-spacer>
                    <v-tooltip color="black" left open-delay="1000" v-if="!tableLoading">
                        <template v-slot:activator="{on, attrs}">
                            <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    icon
                                    small
                                    @click="getSite"
                            >
                                <v-icon small>fas fa-sync</v-icon>
                            </v-btn>
                        </template>
                        <span>Refresh</span>
                    </v-tooltip>

                    <v-tooltip color="black" left open-delay="1000" v-if="!tableLoading && !tokenGenerating && !tokenGenerated">
                        <template v-slot:activator="{on, attrs}">
                            <v-btn v-bind="attrs"
                                   v-on="on"
                                   icon
                                   small
                                   @click="generateToken"
                            >
                                <v-icon small>fas fas fa-key</v-icon>
                            </v-btn>
                        </template>
                        <span>Generate API Key</span>
                    </v-tooltip>

                    <v-tooltip color="black" left open-delay="1000" v-if="!tableLoading && !tokenGenerating && tokenGenerated">
                        <template v-slot:activator="{on, attrs}">
                            <v-btn v-bind="attrs"
                                   v-on="on"
                                   icon
                                   small
                                   v-clipboard="token"
                            >
                                <v-icon small>fas fa-clipboard</v-icon>
                            </v-btn>
                        </template>
                        <span>Copy API Key to clipboard</span>
                    </v-tooltip>

                    <v-btn icon
                           small
                           v-if="tokenGenerating"
                    >
                        <v-icon small>fa-spin far fa-spinner</v-icon>
                    </v-btn>
                </div>

                <div class="Report__report">
                    <v-progress-linear indeterminate v-if="tableLoading"></v-progress-linear>
                    <div v-if="steps" class="Report__steps">
                        <ReportStep v-for="(step, index) in steps" :key="index" :step="step"/>
                    </div>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import axios from 'axios';
import formatDate from '@/helpers/formatDate';
import { mapState } from 'vuex';
import ReportStep from '@/reports/ReportStep';

export default {
    components: { ReportStep },
    computed: {
        ...mapState('auth', ['user']),

        userId: function() {
            return this.$route.params.id;
        },
    },

    data() {
        return {
            tokenGenerated: false,
            tokenGenerating: false,
            token: '',
            steps: [],
            userData: [],
            tableLoading: true,
            headers: [
                {
                    text: 'Step',
                    value: 'name',
                },
                {
                    text: 'Section',
                    value: 'section',
                }
            ],
        };
    },

    mounted() {
        this.getSite();
    },

    methods: {
        getSite() {
            this.tableLoading = true;
            this.steps = [];
            axios
                .get('/api/report/site/single/' + this.userId)
                .then((response) => {
                    this.steps = response.data.data.site;
                    this.userData = response.data.data.user;
                    this.tableLoading = false;
                })
                .catch((error) => {
                    this.error = error;
                    this.tableLoading = false;
                });
        },

        displayDate(date) {
            return formatDate(date);
        },

        exportProject(id) {
            console.log(id);
        },

        generateToken() {
            return new Promise((resolve, reject) => {
                this.tokenGenerating = true;
                axios.post('/api/user/create-own-token')
                    .then(response => {
                        this.token = response.data;
                        this.tokenGenerating = false;
                        this.tokenGenerated = true;
                        resolve();
                    })
                    .catch(error => {
                        console.error(error);
                        this.tokenGenerating = false;
                        reject();
                    });
            });
        },
    }
};
</script>
<style lang="scss">
.Report {
    display: flex;
    flex-flow: row wrap;
    flex: 0 0 100%;
    width: 100%;
}

.Report__heading {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    flex: 0 0 100%;
    width: 100%;
    margin-bottom: 24px;
}

.Report__steps {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    flex: 0 0 100%;
    width: 100%;
}
</style>
